// extracted by mini-css-extract-plugin
export default {"isKeyboardDragging":"DragAndDropContainer-module__isKeyboardDragging__q96KmEj","container":"DragAndDropContainer-module__container__TgNpSA5"};